export enum NotificationStatusEnum {
  PENDING = 'pending',
  LOGGED = 'logged',
  SENT = 'sent',
  ERROR = 'error'
}
